// extracted by mini-css-extract-plugin
module.exports = {"scroll__animation_preview":"animations_scroll__animation_preview___47uU","active":"animations_active__42xa5","scroll__animation":"animations_scroll__animation___Cb0R"};